import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'alga-js'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/analytics';
import "bootstrap-icons/font/bootstrap-icons.css";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID
};

if (process.env.VUE_APP_FIREBASE_MEASUREMENT_ID) {
  firebaseConfig.measurementId = process.env.VUE_APP_FIREBASE_MEASUREMENT_ID;
}

firebase.initializeApp(firebaseConfig)

if (typeof window !== 'undefined' && firebase.analytics && firebaseConfig.measurementId) {
  firebase.analytics();
}

firebase.auth().onAuthStateChanged(function(user) {
  if (user) {
    // User is signed in.
  } else {
    // No user is signed in.
  }
});

createApp(App).use(store).use(router).mount('#app');
